export default __webpack_public_path__ + "static/media/logo_lesni_pedagogika.8872d701.jpg";